import clsx from 'clsx';
import { useEffect, useState } from 'react';

import { Collapse } from '../collapse';

import styles from './animated-loader.module.scss';

import LoadingSvg from './assets/loading.svg?react';

export const AnimatedLoader = (props: AnimatedLoaderProps) => {
  const { visible } = props;

  const [isExpanded, setIsExpanded] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    if (visible) {
      timeoutId = setTimeout(() => {
        setIsExpanded(true);
        setIsAnimating(true);
      }, 200);
    } else {
      setIsAnimating(false);
      timeoutId = setTimeout(() => setIsExpanded(false), 2000);
    }

    return () => clearTimeout(timeoutId);
  }, [visible]);

  return (
    <Collapse open={isExpanded} className={styles.animatedLoaderContainer}>
      <LoadingSvg
        data-visible={visible}
        data-testid="loading-svg"
        className={clsx(styles.animatedLoader, {
          [styles.active]: isAnimating,
        })}
      />
    </Collapse>
  );
};

interface AnimatedLoaderProps {
  visible: boolean;
}
